import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

export const RemoveRouteContent = ({ route }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      {`Are you sure you want to remove route "${route.routeCode}" completely?`}
    </View>
  );
};
